import api from "../apis/SessionApi";
import * as constant from "../constants/SessionConstant";

export const sessionAttendance = (data,onSuccess,onError) => (dispatch) => {
  // console.log(data)
  api.Session().learnerSessionAttendance(data)
       .then(res=> {
         console.log(res)
         onSuccess()
       })
       .catch(err => {
        console.log(err.response)
        onError(err.response.data.message)
        if (err.code === 'ECONNABORTED'){
          console.log("Timeout");
        }else{
        console.log(err.response);
        }
       })
}
export const sessionCancelled = (data,onSuccess,onErr) => dispatch => {
  // console.log(data)
  api.Session().sessionCancelled(data)
       .then(res=> {
        //  console.log(res)
        onSuccess(res.data.message)
       })
       .catch(err => {
        if (err.code === 'ECONNABORTED'){
          onErr("Timeout");
        }else{
        console.log(err.response);
        onErr(err.response.data.message);
        }
       })
}
//GET AVALABLE HOST
export const GetAvalableHost =
  (data, onSuccess, onError, token) => (dispatch) => {
    // console.log(data)
    api
      .Session()
      .getAvalableHost(data, token)
      .then((res) => {
        console.log(res);
        onSuccess(res.data.host.hostName, res.data.blockHostId);
      })
      .catch(err => {
        if (err.code === 'ECONNABORTED'){
          onError("Timeout");
        }else{
        console.log(err.response);
        onError(err.response.data.message);
        }
        })
         
}
//CREATE SESSION
export const CreateSession =
  (data, onSuccess, onError, token) => (dispatch) => {
    console.log(data);
    api
      .Session()
      .createSession(data, token)
      .then((res) => {
        console.log(res);
        onSuccess(res.data.teacherData._id);
      })
      .catch(err => {
        if (err.code === 'ECONNABORTED'){
          onError("Timeout");
        }else{
        console.log(err.response);
        onError(err.response.data.message);
        }
        })
}
//CREATE SESSION NEW
// export const CreateSessionNew = (data,onSuccess,onError) => dispatch => {
// console.log(data)
//   api.Session().createSessionnew(data)
//       .then(res => {
// console.log(res)
//           onSuccess(res.data.teacherData._id)
//       })
//       .catch(err => {
//          // console.log(err.response)
//           onError(err.response.data.message)
//         })
// }

export const TeacherFeedback = (data,onSuccess,onError) => dispatch => {
  api.Session().teacherFeedback(data)
      .then(res => {
          // console.log(res)
         onSuccess()
      })
      .catch(err => {
        if (err.code === 'ECONNABORTED'){
          onError("Timeout");
        }else{
        console.log(err.response);
        onError(err.response.data.message);
        }
        })

}

export const AddSessionFeedback = (data,onSuccess,onError) => async dispatch =>{
  try {
    const response = await api.Session().addRating(data)
    onSuccess(response.data)
  } catch (err) {
    if (err.code === 'ECONNABORTED'){
      onError("Timeout");
    }else{
    console.log(err);
    //onError(err.response.data.message);
    }
  }
}

export const GetSessionFeedback = (data,onSuccess,onError) => async dispatch =>{
  
     api.Session().getRating(data)
     .then(res => {
      onSuccess(res)
      //   dispatch({
      //     type: constant.TEACHER_PAST_SESSION,
      //     payload: res.data
      // })
    })
    .catch(err => {
      if (err.code === 'ECONNABORTED'){
        onError("Timeout");
      }else{
      console.log(err.response);
      onError(err.response.data.message);
      }
      })
}

export const TecherPandingSession = (data) => dispatch => {
  api.Session().teacherPandingRequest(data)
      .then(res => {
          dispatch({
            type: constant.FETCH_TEACHER_PENDING_REQUEST,
            payload: res.data
        })
      })
      .catch(err => {
        if (err.code === 'ECONNABORTED'){
          console.log("Timeout");
        }else{
        console.log(err.response);
        
        }
        })
}

export const AcceptOrDecline = (data,onSuccess,onError) => dispatch => {
  api.Session().acceptORdecline(data)
      .then(res => {
        // console.log(res)
        dispatch({
          type: constant.TEACHER_DECLINE,
          payload: data.sessionID
      })
          onSuccess()
      })
      .catch(err => {
        if (err.code === 'ECONNABORTED'){
          onError("Timeout");
        }else{
        console.log(err.response);
        onError(err.response.data.message);
        }
        })
}

export const TecherUpcomingSession = (data) => dispatch => {
  api.Session().teacherUpcomingSession(data)
      .then(res => {
        console.log(  res)
          dispatch({
            type: constant.TEACHER_UPCOMING_SESSION,
            payload: res.data
        })
      })
      .catch(err => {
        if (err.code === 'ECONNABORTED'){
          console.log("Timeout");
        }else{
        console.log(err.response);
        
        }
        })
}

export const TecherPastSession = (data) => dispatch => {
  api.Session().teacherPastSession(data)
      .then(res => {
          dispatch({
            type: constant.TEACHER_PAST_SESSION,
            payload: res.data
        })
      })
      .catch(err => {
        if (err.code === 'ECONNABORTED'){
          console.log("Timeout");
        }else{
        console.log(err.response);
        
        }
        })
}

export const StudentUpcomingSession = (data) => dispatch => {
  api.Session().studentUpcomingSession(data)
      .then(res => {
        console.log(res.data)
          dispatch({
            type: constant.TEACHER_UPCOMING_SESSION,
            payload: res.data
        })
      })
      .catch(err => {
        if (err.code === 'ECONNABORTED'){
          console.log("Timeout");
        }else{
        console.log(err.response);
        
        }
        })
}

export const StudentPastSession = (data) => dispatch => {
  api.Session().studentPastSession(data)
      .then(res => {
        // console.log(res)
          dispatch({
            type: constant.TEACHER_PAST_SESSION,
            payload: res.data
        })
      })
      .catch(err => {
        if (err.code === 'ECONNABORTED'){
          console.log("Timeout");
        }else{
        console.log(err.response);
        
        }
        })
}

export const AvailableTeacher = (data,onSuccess,onError) => dispatch => {
  console.log(data)
  api.Session().availableTeacher(data)
      .then(res => {
        onSuccess(res.data)
        //   dispatch({
        //     type: constant.TEACHER_PAST_SESSION,
        //     payload: res.data
        // })
      })
      .catch(err => {
        if (err.code === 'ECONNABORTED'){
          onError("Timeout");
        }else{
        console.log(err.response);
        onError(err.response.data.message);
        }
        })
}

export const getRandomTeacherForDemo =
  (data, onSuccess, onError, token) => (dispatch) => {
    console.log(data);
    console.log(token);
    api
      .Session()
      .getRandomTeacherForDemo(data, token)
      .then((res) => {
        onSuccess(res.data);
        //   dispatch({
        //     type: constant.TEACHER_PAST_SESSION,
        //     payload: res.data
        // })
      })
      .catch(err => {
        if (err.code === 'ECONNABORTED'){
          onError("Timeout");
        }else{
        console.log(err.response);
        onError(err.response.data.message);
        }
        })
}

export const getAvailableSlot = (data, onSuccess, onError) => (dispatch) => {
  console.log(data);
  // console.log(token)
  api.Session().getAvailableSlot(data)
      .then(res => {
        onSuccess(res)
        //   dispatch({
        //     type: constant.TEACHER_PAST_SESSION,
        //     payload: res.data
        // })
      })
      .catch(err => {
        if (err.code === 'ECONNABORTED'){
          onError("Timeout");
        }else{
        console.log(err.response);
        onError(err.response.data.message);
        }
        })
}

export const youtubeApproval = (data, onSuccess, onError) => (dispatch) => {
  console.log(data);
  // console.log(token)
  api.Session().youtubeApproval(data)
      .then(res => {
        onSuccess(res)
        console.log(res)
        
        
      })
      .catch(err => {
        if (err.code === 'ECONNABORTED'){
          onError("Timeout");
        }else{
        console.log(err.response);
        onError(err.response.data.message);
        }
        })
}

export const mostUsedTimeSlot = (data,onSuccess,onError) => dispatch => {
  console.log(data)
  api.Session().mostUsedTimeSlot(data)
      .then(res => {
        console.log(res)
        onSuccess(res.data)
        
      })
      .catch(err => {
        if (err.code === 'ECONNABORTED'){
          onError("Timeout");
        }else{
        console.log(err.response);
        onError(err.response.data.message);
        }
        })
}

export const AddChildren = (data,onSuccess,onError, token) => dispatch=>  {
  console.log(data)
  api.Session().addKids(data, token)
      .then(res => {
          console.log(res)
          onSuccess(res.data)
      })
      .catch(err => {
          console.log(err.response)
          onError(err)
        })
}

export const IsPaymentDone = (data,onSuccess,onError) => dispatch => {
  api.Session().isPaymentDone(data)
      .then(res => {
        console.log(res.data)
        onSuccess(res.data)
        //   dispatch({
        //     type: constant.TEACHER_PAST_SESSION,
        //     payload: res.data
        // })
      })
      .catch(err => {
        if (err.code === 'ECONNABORTED'){
          onError("Timeout");
        }else{
        console.log(err.response);
        onError(err.response.data.message);
        }
        })
}
export const TrialTakenOrNot = (data,onSuccess,onError) => dispatch => {
  api.Session().isTrialTakenOrNot(data)
      .then(res => {
        console.log(res.data)
        onSuccess(res.data)
        //   dispatch({
        //     type: constant.TEACHER_PAST_SESSION,
        //     payload: res.data
        // })
      })
      .catch(err => {
        if (err.code === 'ECONNABORTED'){
          onError("Timeout");
        }else{
        console.log(err.response);
        onError(err.response.data.message);
        }
        })
}

export const GetSessionDocs = (data, onSuccess, onError) => (dispatch) => {
  api
    .Session()
    .sessionDocs(data)
    .then((res) => {
      console.log(res.data);
      onSuccess(res.data);
      //   dispatch({
      //     type: constant.TEACHER_PAST_SESSION,
      //     payload: res.data
      // })
    })
    .catch((err) => {
      if (err.code === 'ECONNABORTED'){
        onError("Timeout");
      }else{
      console.log(err.response);
      onError(err.response.data.message);
      }
    })
}
